import { useState } from "react";
import { collection, getDocs, query, where, or } from "firebase/firestore";
import { db } from "../../../../services/firebaseService/connection";

const useEvents = () => {
  const [events, setEvents] = useState([]);
  const [eventsBySeasonLoading, setEventsBySeasonLoading] = useState(false);

  const fetchEventsBySeason = async (groupId, season) => {
    try {
      setEventsBySeasonLoading(true);

      const postsRef = collection(db, "groupAdminPost", groupId, "posts");

      const seasonAsString = String(season);
      const seasonAsNumber = !isNaN(Number(season)) ? Number(season) : -1;

      const q = query(
        postsRef,
        or(
          where("checkIn.season", "==", seasonAsString),
          where("checkIn.season", "==", seasonAsNumber)
        )
      );

      const docsSnapshot = await getDocs(q);

      // Process the matching documents
      const filteredEvents = [];
      docsSnapshot.forEach((doc) => {
        const data = doc.data();
        filteredEvents.push({
          id: doc.id,
          ...data,
        });
      });

      setEvents(filteredEvents);
      return filteredEvents;
    } catch (error) {
      console.error("Error fetching events by season:", error);
      return [];
    } finally {
      setEventsBySeasonLoading(false);
    }
  };

  return {
    events,
    eventsBySeasonLoading,
    fetchEventsBySeason,
  };
};

export default useEvents;
